import { createAction, props } from '@ngrx/store';
import { Pelicula } from 'src/app/models/pelicula.model';

export const setPeliculas = createAction(
  '[Películas] carga películas',
  props<{ peliculas: Pelicula[]}>()
  );
export const unSetPeliculas = createAction('[Películas] descarga películas');
